export const areas = (state) => state.getIn(['areas', 'entities']);
export const areaById = (state, id) => areas(state).get(String(id));
export const areasByIds = (state, ids) => ids.map((id) => areaById(state, id));
